import { DetailCustomerQuotation, FormCustomerQuotationDetailType } from "pages/Sales/Transaction/CustomerQuotation/types";

export const mapCustomerQuotationDetail = (data: DetailCustomerQuotation['detail']): FormCustomerQuotationDetailType[] => {
  return data.map((item) => ({
    customer_quotation_detail_id: item.customer_quotation_detail_id,
    product_id: item.product.product_id,
    product_name: item.product.product_name,
    product_barcode: item.product.product_barcode,
    qty_order: item.qty_order,
    received: item.received ?? 0,
    mr_unit_id: item.mr_unit.mr_unit_id,
    mr_unit_name: item.mr_unit.mr_unit_name,
    price_measure: item.price_measure,
    discount: item.discount,
    total: item.total,
    project_id: item.project.project_id,
    project_name: item.project.project_name,
    tax_id: item.tax.tax_id,
    tax_name: item.tax.tax_name,
    tax_rate: item.tax.rate,
    location_id: item.location.location_id,
    location_name: item.location.location_name,
    soh: item.soh
  }))
}